const state = () => ({
    currentSliderIndex: 0,
    modal: null,
});

const mutations = {
    setModal(state, { name = null, index = 0 }) {
        state.modal = name;
        state.currentSliderIndex = index;
    },
};

export default {
    namespaced: true,
    mutations,
    state,
};
